export default "/profile/images/paypal.png?73350ffa9a10229f6f7d530e3234f7f5";